import {
  fetchChatterAverageResponseTimeByTime,
  fetchChatterAverageResponseTimeByChatter,
  fetchChatterManualVsAiByTime,
  fetchChatterManualVsAiByChatter,
  fetchChatterPpvRateByTime,
  fetchChatterPpvRateByChatter,
  fetchChatterTotalEarningsByChatter,
  fetchChatterTotalEarningsByTime,
  fetchChatterTotalChatsByChatter,
  fetchChatterTotalChatsByTime,
  fetchChatterTotalMessagesByChatter,
  fetchChatterTotalMessagesByTime,
  fetchInfluencerEarningsByContentTypeByInfluencer,
  fetchInfluencerEarningsByContentTypeByTime,
  fetchInfluencerEarningsByMessageTypeByInfluencer,
  fetchInfluencerEarningsByMessageTypeByTime,
  fetchInfluencerNewUsersByTime,
  fetchInfluencerUserInfluencersByTime,
  fetchInfluencerUserInfluencersByInfluencer,
  fetchInfluencerTableData,
  fetchChatterTableData,
} from './asyncThunks';
import { createOrganizationAnalyticsRequestKey } from './requestKey';

const addFetchInfoBuilder = (builder, thunk, stateKey) => {
  builder.addCase(thunk.pending, (state, action) => {
    state[stateKey].pending = true;
    state[stateKey].pendingRequestKey = createOrganizationAnalyticsRequestKey(action.meta.arg);
  });
  builder.addCase(thunk.fulfilled, (state, action) => {
    const requestKey = createOrganizationAnalyticsRequestKey(action.meta.arg);

    state[stateKey].pending = false;
    state[stateKey].loaded = true;
    state[stateKey].data = action.payload.data;
    state[stateKey].fetchedAt = Date.now();
    state[stateKey].requestKey = requestKey;
    state[stateKey].pendingRequestKey = null;
  });
  builder.addCase(thunk.rejected, state => {
    state[stateKey].pending = false;
    state[stateKey].pendingRequestKey = null;
  });
};

export const fetchInfluencerEarningsByContentTypeByTimeBuilder = builder => {
  addFetchInfoBuilder(
    builder,
    fetchInfluencerEarningsByContentTypeByTime,
    'fetchInfluencerEarningsByContentTypeByTimeInfo',
  );
};

export const fetchInfluencerEarningsByContentTypeByInfluencerBuilder = builder => {
  addFetchInfoBuilder(
    builder,
    fetchInfluencerEarningsByContentTypeByInfluencer,
    'fetchInfluencerEarningsByContentTypeByInfluencerInfo',
  );
};

export const fetchInfluencerEarningsByMessageTypeByTimeBuilder = builder => {
  addFetchInfoBuilder(
    builder,
    fetchInfluencerEarningsByMessageTypeByTime,
    'fetchInfluencerEarningsByMessageTypeByTimeInfo',
  );
};

export const fetchInfluencerEarningsByMessageTypeByInfluencerBuilder = builder => {
  addFetchInfoBuilder(
    builder,
    fetchInfluencerEarningsByMessageTypeByInfluencer,
    'fetchInfluencerEarningsByMessageTypeByInfluencerInfo',
  );
};

export const fetchInfluencerNewUsersByTimeBuilder = builder => {
  addFetchInfoBuilder(builder, fetchInfluencerNewUsersByTime, 'fetchInfluencerNewUsersByTimeInfo');
};

export const fetchInfluencerUserInfluencersByTimeBuilder = builder => {
  addFetchInfoBuilder(builder, fetchInfluencerUserInfluencersByTime, 'fetchInfluencerUserInfluencersByTimeInfo');
};

export const fetchInfluencerUserInfluencersByInfluencerBuilder = builder => {
  addFetchInfoBuilder(
    builder,
    fetchInfluencerUserInfluencersByInfluencer,
    'fetchInfluencerUserInfluencersByInfluencerInfo',
  );
};

export const fetchInfluencerTableDataBuilder = builder => {
  addFetchInfoBuilder(builder, fetchInfluencerTableData, 'fetchInfluencerTableDataInfo');
};

export const fetchChatterTotalEarningsByTimeBuilder = builder => {
  addFetchInfoBuilder(builder, fetchChatterTotalEarningsByTime, 'fetchChatterTotalEarningsByTimeInfo');
};

export const fetchChatterTotalEarningsByChatterBuilder = builder => {
  addFetchInfoBuilder(builder, fetchChatterTotalEarningsByChatter, 'fetchChatterTotalEarningsByChatterInfo');
};

export const fetchChatterTotalMessagesByChatterBuilder = builder => {
  addFetchInfoBuilder(builder, fetchChatterTotalMessagesByChatter, 'fetchChatterTotalMessagesByChatterInfo');
};

export const fetchChatterTotalMessagesByTimeBuilder = builder => {
  addFetchInfoBuilder(builder, fetchChatterTotalMessagesByTime, 'fetchChatterTotalMessagesByTimeInfo');
};

export const fetchChatterTotalChatsByChatterBuilder = builder => {
  addFetchInfoBuilder(builder, fetchChatterTotalChatsByChatter, 'fetchChatterTotalChatsByChatterInfo');
};

export const fetchChatterTotalChatsByTimeBuilder = builder => {
  addFetchInfoBuilder(builder, fetchChatterTotalChatsByTime, 'fetchChatterTotalChatsByTimeInfo');
};

export const fetchChatterAverageResponseTimeByChatterBuilder = builder => {
  addFetchInfoBuilder(
    builder,
    fetchChatterAverageResponseTimeByChatter,
    'fetchChatterAverageResponseTimeByChatterInfo',
  );
};

export const fetchChatterAverageResponseTimeByTimeBuilder = builder => {
  addFetchInfoBuilder(builder, fetchChatterAverageResponseTimeByTime, 'fetchChatterAverageResponseTimeByTimeInfo');
};

export const fetchChatterManualVsAiByTimeBuilder = builder => {
  addFetchInfoBuilder(builder, fetchChatterManualVsAiByTime, 'fetchChatterManualVsAiByTimeInfo');
};

export const fetchChatterManualVsAiByChatterBuilder = builder => {
  addFetchInfoBuilder(builder, fetchChatterManualVsAiByChatter, 'fetchChatterManualVsAiByChatterInfo');
};

export const fetchChatterPpvRateByTimeBuilder = builder => {
  addFetchInfoBuilder(builder, fetchChatterPpvRateByTime, 'fetchChatterPpvRateByTimeInfo');
};

export const fetchChatterPpvRateByChatterBuilder = builder => {
  addFetchInfoBuilder(builder, fetchChatterPpvRateByChatter, 'fetchChatterPpvRateByChatterInfo');
};

export const fetchChatterTableDataBuilder = builder => {
  addFetchInfoBuilder(builder, fetchChatterTableData, 'fetchChatterTableDataInfo');
};
